export default "__VITE_ASSET__CGWvveon__"